export function getImageDimensions(file: File): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(url); // Clean up
    };

    img.onerror = () => {
      reject(new Error('Failed to load image.'));
      URL.revokeObjectURL(url);
    };

    img.src = url;
  });
}
